export const columnsSummary = [
    { header: "", accessor: "name", className: "transfer-prepak__table--col1" },
    { header: "Fit", accessor: "amountFit", bold: false, className: "transfer-prepak__table--col2" },
    { header: "Processed", accessor: "amountProcessed", bold: false, className: "transfer-prepak__table--col3" },
    { header: "Unprocessed", accessor: "amountUnprocessed", bold: false, className: "transfer-prepak__table--col4" },
    { header: "Total", accessor: "total", bold: false },
]
export const categories = [{ name: "fit" }, { name: "processed" }, { name: "unprocessed" }]
